
















































import { PropType } from 'vue';
import { Page } from './models.ts';

import CoCard from '../co-card/CoCard.vue';
import CoThumbnail from '../co-thumbnail/CoThumbnail.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoPage from '../co-page/CoPage.vue';

export default {
    name: 'CoCardPage',
    components: {
        CoCard,
        CoThumbnail,
        CoText,
        CoPage,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        page: {
            type: Object as PropType<Page>,
            default: () => ({} as Page),
        },
    },
    computed: {
        // Compare against the active space so the header only renders for cross-space pages.
        thisSpaceID() {
            return this.$store?.state?.space?.ID || null;
        },
    },
};
